export const region1AllotmentTables = {
  '2026': {
    title: '2026 Region 1 Allotment Summary',
    asOf: '2026-02-01',
    source: '2026 Region 1 - Allotment Table V1.pdf',
    rows: [
      { level: 'Level 4', ageGroup: '7-10', allotment: 132, competingAtStates: 192, az: 10, nv: 6, hi: 3, nc: 63, sc: 39, ut: 10 },
      { level: 'Level 4', ageGroup: '11-19', allotment: 120, competingAtStates: 144, az: 15, nv: 4, hi: 1, nc: 58, sc: 30, ut: 12 },
      { level: 'Level 5', ageGroup: '8-19', allotment: 120, competingAtStates: 222, az: 15, nv: 6, hi: 1, nc: 48, sc: 42, ut: 8 },
      { level: 'Level 6', ageGroup: '10-19', allotment: 70, competingAtStates: 70, allQualify: true },
      { level: 'Level 7', ageGroup: '12-19', allotment: 132, competingAtStates: 142, allQualify: true },
      { level: 'Level 8', ageGroup: '12-13', allotment: 48, competingAtStates: 48, allQualify: true },
      { level: 'Level 8', ageGroup: '14-19', allotment: 62, competingAtStates: 62, allQualify: true },
      { level: 'Level 9', ageGroup: '14-15', allotment: 61, competingAtStates: 61, allQualify: true },
      { level: 'Level 9', ageGroup: '16-19', allotment: 71, competingAtStates: 71, allQualify: true },
      { level: 'Level 10', ageGroup: '16-17', allotment: 77, competingAtStates: 77, allQualify: true },
      { level: 'Level 10', ageGroup: '18-19', allotment: 58, competingAtStates: 58, allQualify: true }
    ],
    totals: {
      allotment: 951,
      competingAtStates: 1147
    }
  }
};

